const TEAM_PREFIX_REGEX = /^\/t\/([^/?#]+)(.*)?$/;

export function getTeamKeyFromPath(pathname: string): string | null {
  const match = pathname.match(TEAM_PREFIX_REGEX);
  return match ? match[1] : null;
}

export function buildTeamPath(teamKey: string, path = '/'): string {
  return `/t/${teamKey}${path}`;
}

export function stripTeamPrefix(pathname: string): string {
  const match = pathname.match(TEAM_PREFIX_REGEX);
  if (!match) return pathname;
  const rest = match[2] || '';
  // If the rest starts with / it's a sub-path – return as-is.
  // Otherwise it starts with ? or # (or is empty) – prepend / so the
  // caller always gets an absolute inner path.
  return rest.startsWith('/') ? rest : `/${rest}`;
}
